var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HSCodeCreateAdmin',{attrs:{"HSCode":_vm.HSCode,"serverError":_vm.serverError},on:{"createHSGroup":_vm.createHSGroup}})
}
var staticRenderFns = []

export { render, staticRenderFns }